enum WorkspaceProjectUpdateType {
  none = 'none',
  annual_report = 'annual_report',
  milestone = 'milestone',
  project = 'project',
  project_result = 'project_result',
}

export default WorkspaceProjectUpdateType
